export const CARD_SLIDER_GROUP_SIZE = 6
